import {Add} from '@mui/icons-material'
import {Button} from '@mui/material'
import React, {FC} from 'react'
import {useTranslation} from 'react-i18next'

import {ActionDialogWrapper} from '../components'
import {FEATURE_NAMESPACE} from '../consts'
import {ActionItem, Category} from '../types'

import {ActionsCardContainer} from './ActionsCardContainer'
import {SectionsOverview} from './SectionsOverview'
import {Tab, TabSectionContainer} from './TabSectionContainer'

export enum PlantCardTab {
  Categories,
  Actions
}

type PlantSideCardContainerProps = {
  actions: ActionItem[]
  sections: Category[]
  onSectionRowClick: (id: string) => void
}

export const PlantSideCardContainer: FC<PlantSideCardContainerProps> = ({
  actions,
  onSectionRowClick,
  sections
}) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)

  const tabs: Tab<PlantCardTab>[] = [
    {
      index: PlantCardTab.Categories,
      label: t('sectionsOverview.title', {sectionsCount: sections.length}),
      component: <SectionsOverview sections={sections} onRowClick={onSectionRowClick} />
    },
    {
      index: PlantCardTab.Actions,
      label: t('actionsCard.title', {actionsCount: actions.length}),
      component: <ActionsCardContainer actions={actions} />
    }
  ]

  return (
    <TabSectionContainer<PlantCardTab>
      tabs={tabs}
      initialTab={PlantCardTab.Categories}
      getTabAction={(tab) =>
        tab === PlantCardTab.Actions && (
          <ActionDialogWrapper
            opener={
              <Button
                sx={{height: 48}}
                variant={'text'}
                startIcon={<Add />}
                data-test-id="add-action"
              >
                {t('addAction.heading')}
              </Button>
            }
          />
        )
      }
    />
  )
}
